import React, { useState } from "react";
import { connect } from "react-redux";
import { deleteOrg } from "domain/actions/organizations/created";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";

function DeleteButton(props) {
  const [visible, setVisible] = useState(false);

  const accept = () => {
    props.deleteOrg();
  };
  const reject = () => {
    setVisible(false);
  };

  return (
    <div className={props.className}>
      <ConfirmDialog
        visible={visible}
        onHide={() => setVisible(false)}
        message="Вы действительно хотите деактивировать организацию?"
        header="Подтверждение"
        icon="pi pi-exclamation-triangle"
        accept={accept}
        reject={reject}
      />

      <Button
        label="Деактивировать"
        className="с-button-danger"
        onClick={() => setVisible(true)}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  isValid: state.orgCreate.isValid,
});
export default connect(mapStateToProps, { deleteOrg })(DeleteButton);
